var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tooltip',{attrs:{"content":'Time tag',"open-delay":350,"transition":"el-zoom-in-bottom","effect":"dark","placement":"top"}},[_c('time-tag',{staticClass:"time-tag-button",class:{ inactive: !_vm.isActiveTimeTag },attrs:{"command":_vm.toggleTimeTag,"time":this.time}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }